/*
 * Pagination Messages
 *
 * This contains all the text for the Pagination component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  previous: {
    id: 'app.components.Pagination.previous',
    defaultMessage: 'Previous',
  },
  next: {
    id: 'app.components.Pagination.next',
    defaultMessage: 'Next',
  },
  paginationText: {
    id: 'app.containers.Pagination.paginationText',
    defaultMessage: '{start}–{end} of {total}',
  },
});
